var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDropdown = function SvgDropdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#242222",
    d: "m8.25 2.088 4 3.2.313.25-.5.625-.313-.25-3.75-3-3.75 3-.313.25-.5-.625.313-.25 4-3.2.25-.2zm0 11.825-.25.2-.25-.2-4-3.2-.313-.25.5-.625.313.25 3.75 3 3.75-3 .313-.25.5.625-.313.25z"
  })));
};
export default SvgDropdown;